import { isBarberSessionView, isShopSessionView, useSession, } from '../../../../infra/session';
import { useCampaignDetails } from './use-campaign-details';
export var useCanSeePromotion = function (campaignId) {
    var session = useSession().data;
    var campaign = useCampaignDetails(campaignId, false).campaign;
    var isBarberView = session ? isBarberSessionView(session.view) : false;
    var isShopView = session ? isShopSessionView(session.view) : false;
    var isCommissionContext = false;
    if (isBarberView || isShopView) {
        isCommissionContext = session.view.meta.commission;
    }
    var isCommissionBarber = isBarberView && isCommissionContext;
    var isNewCampaign = !campaignId;
    if (isNewCampaign) {
        return !isCommissionBarber;
    }
    var createdByCommissionBarber = isShopView && (campaign === null || campaign === void 0 ? void 0 : campaign.ownerType) === 'barber' && isCommissionContext;
    return !isCommissionBarber && !createdByCommissionBarber;
};
